import dayjs from "dayjs";

import {
    hasLegacyMarquee,
    IKioskData,
    IMarqueeDataItem,
    IScheduleMarqueeFormDataNew,
    isNewMarqueeFormat,
    isOldMarqueeArrayFormat,
} from "../../types";
import { convertLegacyToNewFormat, convertOldScheduleToNewFormat } from "./convertMarqueeData";

/**
 * 判斷 kioskSetting 資料格式並正規化為統一格式
 * @param kioskData kioskSetting 資料
 * @param languageOptions 語言選項
 * @returns 正規化後的資料
 */
export const normalizeMarqueeData = (
    kioskData: IKioskData | null | undefined,
    languageOptions: Array<{ label: string; value: string }>
): IScheduleMarqueeFormDataNew | null => {
    if (!kioskData) return null;

    const defaultDateStart = dayjs().format("YYYY/MM/DD HH:mm");
    const defaultDateEnd = dayjs().add(1, "day").format("YYYY/MM/DD HH:mm");
    const defaultLanguage = languageOptions[0]?.value || "zh-TW";

    const scheduleMarquee = kioskData.native?.schedule_marquee;

    // 1. 新格式 - native.schedule_marquee 為物件且包含 data 陣列
    if (isNewMarqueeFormat(scheduleMarquee)) {
        return {
            schedule_marquee: {
                enable_marquee: scheduleMarquee.enable_marquee,
                position: scheduleMarquee.position || "top",
                data: scheduleMarquee.data.map((item: IMarqueeDataItem) => ({
                    ...item,
                    start_at: dayjs(item.start_at).isValid()
                        ? dayjs(item.start_at).format("YYYY/MM/DD HH:mm")
                        : item.start_at,
                    end_at: dayjs(item.end_at).isValid() ? dayjs(item.end_at).format("YYYY/MM/DD HH:mm") : item.end_at,
                    selectedLanguages:
                        item.selectedLanguages ||
                        (item.content && item.content.length > 0 ? Object.keys(item.content[0]) : [defaultLanguage]),
                })),
            },
        };
    }

    // 2. 舊陣列格式 - native.schedule_marquee 為陣列
    if (isOldMarqueeArrayFormat(scheduleMarquee)) {
        return convertOldScheduleToNewFormat(scheduleMarquee, languageOptions, defaultDateStart, defaultDateEnd);
    }

    // 3. Legacy 格式 - marquee 欄位
    if (hasLegacyMarquee(kioskData) && kioskData.marquee) {
        return convertLegacyToNewFormat(kioskData.marquee, languageOptions, defaultDateStart, defaultDateEnd);
    }

    return null;
};
